const getImageBaseUrl = () => {
  const localImageBase = "http://127.0.0.1:8000";
  const rawImageBase = process.env.REACT_APP_IMAGE_URL || "";
  const rawApiBase = process.env.REACT_APP_API_URL || "";
  const imageBase =
    process.env.NODE_ENV === "development" && rawImageBase.includes("asysta.in")
      ? localImageBase
      : rawImageBase;
  const apiBase =
    process.env.NODE_ENV === "development" && rawApiBase.includes("asysta.in")
      ? `${localImageBase}/api/v1`
      : rawApiBase;
  return (imageBase || apiBase).replace(/\/api\/v1\/?$/i, "").replace(/\/+$/, "");
};

export const resolveAssetUrl = (path, fallback = "") => {
  if (path === null || path === undefined) return fallback;

  const raw = String(path).trim();
  if (!raw || raw === "null" || raw === "undefined") return fallback;
  if (/^(https?:)?\/\//i.test(raw) || raw.startsWith("data:") || raw.startsWith("blob:")) {
    return raw;
  }

  const clean = raw
    .replace(/\\/g, "/")
    .replace(/^\/+/, "")
    .replace(/^backend\/public\//i, "")
    .replace(/^public\//i, "")
    .replace(/^storage\/app\/public\//i, "storage/");

  const base = getImageBaseUrl();
  return base ? `${base}/${clean}` : `/${clean}`;
};
